export const types = {
  SET_REQUEST_STATS: 'SET_REQUEST_STATS',
  SET_USER_REQUEST_GRAPH: 'SET_USER_REQUEST_GRAPH',
};
